import { Loader } from 'core/elements';
import { CorporatePartNotSetUp } from 'corporate/components/CorporatePartNotSetUp';
import { CorporatePartHelper } from 'corporate/helpers';
import { ICorporatePart } from 'corporate/types';
import { IExternalPricesResponse } from 'parts/types';
import { Size } from 'theme/enums';

import { AlternatePartCards } from './AlternatePartCards';
import { LegacyPartCards } from './LegacyPartCards';

export interface IPartCardsProps {
  corporatePart?: Partial<ICorporatePart>;
  externalPricing?: IExternalPricesResponse | null;
  isCorporatePartLoading?: boolean;
  isAlternateVersionEnabled?: boolean;
  inline?: boolean;
}

export const PartCards = ({
  corporatePart,
  externalPricing,
  isCorporatePartLoading,
  isAlternateVersionEnabled,
  inline,
}: IPartCardsProps) => {
  if (isCorporatePartLoading) {
    return <Loader size={Size.SM} style={{ justifyContent: 'flex-start', height: 'auto' }} />;
  }

  if (!isAlternateVersionEnabled && !CorporatePartHelper.isSetUp(corporatePart)) {
    return <CorporatePartNotSetUp />;
  }

  if (isAlternateVersionEnabled) {
    return (
      <AlternatePartCards
        corporatePart={corporatePart}
        externalPricing={externalPricing}
        inline={inline}
      />
    );
  }

  // Legacy cards still need this: `isSetUp` lets a PNB part through without an id.
  if (!corporatePart?.id) {
    return null;
  }

  return <LegacyPartCards corporatePart={corporatePart} inline={inline} />;
};
